import { createSelector } from 'reselect';
import { WINE_OFFER_2ND_GROUP_NAME } from './constants';
import {
  getPromotionThresholdById,
  getPromotionDescription,
  getPromotionById,
  getProductsByPromotionId,
  getIsTimeOrSlotOutsideOfferPeriod,
} from '.';
import { getBlendedOptimisticTrolleyItems } from '../../../trolley/selectors/get-optimistic-items';

const EMPTY_ARRAY = [];

export const getWineOfferProductsInTrolley = createSelector(
  [getBlendedOptimisticTrolleyItems, getProductsByPromotionId],
  (blendedTrolleyItems = [], products = []) => {
    const linesMap = [];

    products.forEach(prod => {
      const trolleyItem = blendedTrolleyItems.find(item => item.lineNumber === prod.lineNumber);

      for (let i = 0; i < trolleyItem?.quantity.amount; i += 1) {
        linesMap.unshift(trolleyItem);
      }
    });

    return linesMap;
  },
);

export const getWineOfferTrolleyItemsGrouped = createSelector(
  getWineOfferProductsInTrolley,
  getPromotionThresholdById,
  (wineTrolleyItems = [], threshold) => {
    const linesMap = [];

    if (wineTrolleyItems.length < threshold) {
      const group = wineTrolleyItems;

      for (let i = group.length; i < threshold; i += 1) {
        group.push(null);
      }

      linesMap.push(group);

      return linesMap;
    }

    const firstGroup = wineTrolleyItems.slice(0, threshold);

    let secondGroup = [];

    if (threshold) {
      secondGroup = wineTrolleyItems.slice(threshold || 0);
    }

    secondGroup.push(null);

    linesMap.push(firstGroup, secondGroup);

    return linesMap;
  },
);

export const getWineOfferBuilderItems = createSelector(
  getPromotionThresholdById,
  getWineOfferTrolleyItemsGrouped,
  getPromotionById,
  getPromotionDescription,
  getIsTimeOrSlotOutsideOfferPeriod,
  (
    threshold,
    groupedTrolleyItems,
    promotion,
    promotionDescription,
    isTimeOrSlotOutsideOfferPeriod,
  ) => {
    if (!promotion) {
      return EMPTY_ARRAY;
    }

    if (isTimeOrSlotOutsideOfferPeriod) {
      return EMPTY_ARRAY;
    }

    return [
      {
        ...promotion,
        completed: groupedTrolleyItems.length > 1,
        groups: groupedTrolleyItems.map((items, index) => ({
          groupId: index.toString(),
          threshold,
          items,
          name: index > 0 ? WINE_OFFER_2ND_GROUP_NAME : '',
        })),
        builderId: 0,
        savings: promotionDescription,
      },
    ];
  },
);
